<template>
  <div class="export-paper-with-svg">
    <div class="export-paper-with-svg-stub">
      <img
        :src="uploadIcon"
        alt=""
      >
    </div>
    <div
      v-if="options[exportType]"
      class="export-paper-with-svg-container"
    >
      <div
        class="export-paper-with-svg-icon"
      >
        <img
          :src="options[exportType].icon"
          alt=""
        >
      </div>
    </div>
  </div>
</template>

<script>

const __ = window.__;

export default {
  name: 'PaperWithSvg',
  components: { },
  props: {
    exportType: {
      type: String,
      default: 'xml',
    },
  },
  data() {
    return {
      options: {
        xml: {
          icon: `${GT.cdn}/imgs/export/xml_file.svg`,
          css: 'xml',
        },
      },
      uploadIcon: `${GT.cdn}/imgs/export/xml_data.svg`,
    };
  },
};
</script>

<style scoped>

</style>
